import $ from 'jquery';
import Reactor from 'javascripts/reactive_rails';
import { set } from 'lodash';

export function updateReactiveParams(
  $reactiveContainer: JQuery<HTMLElement>,
  partialParams: JQuery.PlainObject
) {
  // Update the URL directly, force update the element, then save the pref
  const url = new URL(
    $reactiveContainer.attr('data-reactive-url') || '',
    window.location.href
  );

  // $.param converts partialParams into a flat string, so here we're using
  // URLSearchParams to break it back apart so we can iterate below
  const urlParams = new URLSearchParams($.param(partialParams));

  for (const [key, value] of urlParams) {
    if (Array.isArray(value)) {
      url.searchParams.delete(key);
      value.forEach((v: string) => url.searchParams.append(`${key}[]`, v));
    } else if (value === null || value === '') {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  }

  $reactiveContainer.attr('data-reactive-url', url.href);

  return Reactor.updateReactiveElement($reactiveContainer);
}

$(document).on(
  'click.reactivePartialParams',
  '[data-reactive-partial-params]',
  event => {
    event.preventDefault();

    if (!event.currentTarget) return;

    const $target = event.currentTarget;
    const partialParams = JSON.parse(
      $target.dataset.reactivePartialParams
    ) as JQuery.PlainObject;
    const partialId = $target.dataset.reactivePartialId;

    let $reactiveContainer: JQuery<HTMLElement>;

    if (partialId) {
      $reactiveContainer = $('#' + partialId);
    } else {
      const portalElement = event.currentTarget.closest('[data-reactive-url]');
      if (!portalElement) return;

      $reactiveContainer = $(portalElement);
    }

    updateReactiveParams($reactiveContainer, partialParams);
  }
);

$(document).on(
  'input.reactivePartialInput',
  '[data-reactive-partial-input]',
  event => {
    const reactiveContainer = event.currentTarget.closest(
      '[data-reactive-url]'
    );
    if (!reactiveContainer) return;

    const inputPath = event.currentTarget.dataset.reactivePartialInput;
    if (!inputPath) return;

    const params = {};
    set(params, inputPath, event.currentTarget.value);
    updateReactiveParams($(reactiveContainer), params);
  }
);
